// test1912
(1912 && 0);
